<div class="posts uilab-layout-container">
    @if (loading) {
    <app-page-blockframe></app-page-blockframe>
    } @if (!loading) {
    <div class="uilab-main-canvas">
        <div class="page-title">
            <h1>What's new</h1>
            <img [src]="headerImage" alt="What's new header icon" />
        </div>

        @for (post of posts; track $index) {
        <div class="post">
            <h2>{{post.title}}</h2>
            <app-inner-content [content]="post.content"></app-inner-content>
        </div>
        } @if (error) {
        <app-error [error]="error"></app-error>
        }
    </div>
    }
</div>
